import { CommonModule } from '@angular/common';
import { Component, Input, NgModule } from '@angular/core';
import { SignOffSummaryCardModule } from '@data-terminal/feature-dialogs/components/sign-off-summary/sign-off-summary-card/sign-off-summary-card.component';
import { SignOffMachine } from '@data-terminal/shared-models/machine';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'data-terminal-sign-off-summary',
    templateUrl: './sign-off-summary.component.html',
    styleUrls: ['./sign-off-summary.component.scss'],
    standalone: false,
})
export class SignOffSummaryComponent {
    @Input() public signOffMachines!: SignOffMachine[];
}

@NgModule({
    declarations: [SignOffSummaryComponent],
    exports: [SignOffSummaryComponent],
    imports: [SignOffSummaryCardModule, CommonModule, TranslateModule],
})
export class SignOffSummaryModule {}
